import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useCrudSelection, resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { selectTrafficAreasListStructure } from '@/features/domain/lists'

export function useTitle() {
  const listStructure = useSelector(selectTrafficAreasListStructure)

  const [selection, select] = useCrudSelection('trafficArea')
  const { editing } = useEditingStateWithCtx('trafficArea')

  const onSelectAll = useCallback(() => {
    const allSelected = listStructure.shownItems <= selection.length

    if (allSelected) {
      resetCrudSelection('trafficArea')
    } else {
      select(
        listStructure.list.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
      )
    }
  }, [select, selection, listStructure])

  return {
    editing,
    selection,
    onSelectAll,
    listStructure,
    noEntries: listStructure.totalItems === 0,
  }
}
